import { Box, MenuItem, Stack, TextField } from "@mui/material";
import React from "react";
import { banques } from "../asset/variables";

export default function CompteBqForm(props) {

    return(
        <Box display='flex' flex={1} flexDirection='column' rowGap={2}>
            <TextField autoFocus={!props.noFocus} fullWidth required sx={{minWidth:'200px', width:'100%'}} label={"Libellé"} value={props.compte.libelle} 
            onChange={(e)=>props.setBanques(old=>{old[props.index].libelle=e.target.value; return[...old]})}/>
            
            <Stack direction='row' spacing={2} alignItems='center'>
                <TextField  fullWidth required sx={{minWidth:'200px'}} label={"N° compte"} value={props.compte.num_compte} onChange={(e)=>props.setNum(e.target.value)}/>
                <TextField type="number" fullWidth sx={{minWidth:'70px'}} label={"Solde"} value={props.compte.solde} 
                onFocus={()=>{if(props.compte.solde===0) props.setBanques(old=>{old[props.index].solde = ''; return [...old]})}}
                onChange={(e)=>{if(/^-?\d*([,.]\d{1,2})?$/.test(e.target.value)){
                    props.setBanques(old=>{old[props.index].solde = e.target.value===''? '': Number(parseFloat(e.target.value).toFixed(2)); return [...old]})
                }}}/>
            </Stack>
            
            <Stack direction='row' spacing={2} alignItems='center'>
                <TextField fullWidth select required sx={{minWidth:'200px'}} label="Banque" value={props.compte.banque} onChange={(e)=>props.setBanque(e.target.value)}>
                    {banques.map(bq=><MenuItem key={bq} value={bq} sx={{textTransform: 'capitalize'}}>{bq}</MenuItem>)}
                </TextField>
                <TextField fullWidth required sx={{minWidth:'200px'}} label={"N° compte bancaire"} value={props.compte.num_banque} onChange={(e)=>props.setNum_banque(e.target.value)}/>         
            </Stack>
        </Box>
    )
}